<template>
    <svg :width="width" :height="height" :viewBox="getViewBox" :class="className">
        <use :xlink:href="getName" />
    </svg>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { BasicIcons } from "./basic-icons";

const props = withDefaults(
    defineProps<{
        name: BasicIcons;
        width?: number;
        height?: number;
    }>(),
    {
        width: 16,
        height: 16
    }
);

const className = computed(() => `svg-ico-${props.name}`);

const getViewBox = computed(() => {
    return `0 0 ${props.height} ${props.width}`;
});

const getName = computed(() => `/frontend/kasa-loyalty/img/icons/basic/${props.name}.svg#${props.name}`);
</script>
